/**
 * The till this machine used last.
 *
 * Remembered per device rather than per user: "CAIXA 01" is a property of the
 * counter the machine sits on, not of whoever is standing at it, and typing it
 * again at the start of every shift is the sort of friction that ends with
 * everybody using the default.
 *
 * A MEMORY OF THE LAST CHOICE and not the source of the value. If what is
 * stored here is no longer in the register — archived, or a machine moved
 * between shops — `TerminalSelect` opens empty rather than carrying a ghost
 * into the abertura.
 */

const STORAGE_KEY = 'aeris.cash-terminal'

export const readRememberedTerminal = (): string =>
  window.localStorage.getItem(STORAGE_KEY) ?? ''

export const rememberTerminal = (code: string): void => {
  window.localStorage.setItem(STORAGE_KEY, code)
}
